import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type SpinnerProps = {
	width?: string;
	height?: string;
	color?: string;
	label?: string;
	className?: string;
};

const Spinner = ({
	width = 'w-6',
	height = 'h-6',
	color = 'primary',
	label = 'loading',
	className,
}: SpinnerProps) => {
	const { t } = useTranslation();
	return (
		<div
			className={twMerge('flex items-center justify-center', className)}
			role='status'
			aria-live='polite'
		>
			<div
				className={`${width} ${height} rounded-full animate-spin border-2 border-solid ${color ? `border-${color}` : 'border-primary'} border-t-transparent`}
			></div>
			<span className='sr-only'>{t(label)}</span>
		</div>
	);
};

export default Spinner;
